import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';

function ProfileMenu() {
  const { username, role, avatarUrl, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) setIsOpen(false);
    };
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen]);

  const initials = username ? username.slice(0, 2).toUpperCase() : '??';

  return (
    <div className="profile-menu" ref={containerRef}>
      <button type="button" className="profile-menu-btn" onClick={() => setIsOpen((open) => !open)} aria-label="Account menu" title="Account menu">
        {avatarUrl ? (
          <img src={avatarUrl} alt="" className="profile-avatar profile-avatar-img" />
        ) : (
          <span className="profile-avatar">{initials}</span>
        )}
      </button>
      {isOpen && (
        <div className="profile-menu-panel">
          <div className="profile-menu-username">{t('profileMenu.greeting', { username })}</div>
          <div className="profile-menu-theme-row">
            <span>{t('profileMenu.theme')}</span>
            <button type="button" className="theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
              {theme === 'light' ? '🌙' : '☀️'}
            </button>
          </div>
          <Link to="/settings" className="profile-menu-item" onClick={() => setIsOpen(false)}>⚙ {t('profileMenu.settings')}</Link>
          <Link to="/how-to-use" className="profile-menu-item" onClick={() => setIsOpen(false)}>❔ {t('profileMenu.howToUse')}</Link>
          {role === 'user' && (
            <Link to="/support" className="profile-menu-item" onClick={() => setIsOpen(false)}>🛟 {t('profileMenu.support')}</Link>
          )}
          <button type="button" className="profile-menu-item danger" onClick={logout}>🚪 {t('profileMenu.logout')}</button>
        </div>
      )}
    </div>
  );
}

export default ProfileMenu;
